<template>
  <div>
    <div class="five-nav flex-start">
      <div
        v-for="(item,index) in content"
        @click="goGoodsList(item.url.name,item.url.query.cate_id)"
      >
        <div class="nav-img-box">
          <img :src="item.pic_url" />
        </div>
        <div style="margin-top:0.2rem;font-size: 11px;color: #333;">{{item.title}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavButton",
  components: {},
  props: {
    content: {
      type: Array,
      default: []
    }
  },

  data: function() {
    return {};
  },

  methods: {
    goGoodsList(url, cate_id) {
      console.log(cate_id);
      if (cate_id == 0) {
        // this.$router.push({
        //   path: "/goodscates"
        // });
        rbLink({
          name: "GoodsCates",
          query: {}
        });
        return;
      }

      rbLink({
        name: url.substring(0, 1).toUpperCase() + url.substring(1),
        query: { cate_id: cate_id }
      });
      //   this.$router.push({

      //     // path: "/" + url,
      //     // query: {
      //     //   cate_id: cate_id
      //     // }
      //   });
    }
  },

  filters: {}
};
</script>

<style scoped>
.nav-img-box {
  height: 0.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.five-nav {
  background: #fff;
  width: 7.1rem;
  margin: 0 auto;
}

.five-nav > div {
  flex: 1;
  text-align: center;
  padding: 0.2rem 0;
}

.five-nav img {
  width: 1rem;
  /* height: 0.6rem; */
}
</style>


// WEBPACK FOOTER //
// NavButton.vue?e289d802